<template>
    <div>
    <p>This is an executable installer with no bundled Java Runtime.
        You need to download and install Java separately.</p>

    <div class="p-3">
        <strong>GanttProject {{ version }}</strong>
        <div class="help-text pb-3">Released on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/win`">Download</a>
    </div>

    <p>GanttProject {{ version }} requires Java Runtime version 7 or higher.
        Currently there is a number of Java Runtime vendors and versions.
        GanttProject works with any OpenJDK compatible Java Runtime, however, due to packaging
        and other reasons, it may not work out of the box with some combinations of operating system,
        Java Runtime vendor and version.</p>

    <p>GanttProject has been smoke-tested on the following configurations:</p>
    <ul>
        <li>Windows 8 with Oracle Java Runtime version 7                   </li>
        <li>Windows 8 with AdoptOpenJDK Java Runtime versions 8 and 11     </li>
        <li>Windows 8 with Amazon Corretto Java Runtime versions 8 and 11  </li>
        <li>Windows 10 with AdoptOpenJDK Java Runtime versions 8, 11 and 14</li>
        <li>Windows 10 with Amazon Corretto Java Runtime versions 8 and 11 </li>
    </ul>

    <p><strong>Important:</strong> when installing AdoptOpenJDK Java Runtime,
        make sure to select option "JavaSoft (Oracle) registry keys".</p>


    <h4>Reports from anti-virus software</h4>

    <p>Some anti-virus programs may report viruses in the installer. This is a known issue which happens
        to installers very often. It doesn't mean that the file is infected, it rather means that antivirus
        engine have seen malware packed using similar installer.</p>

    <p>The installer was <a :href="`https://www.virustotal.com/gui/file/${virustotalHash}/detection`">checked by VirusTotal</a>
        and at the moment of writing this no engines reported positive results (which is good).</p>

    <p>If your anti-virus software reports positive result, this is most likely a false positive,
        provided that the file which you downloaded is the original one. You can check if you downloaded
        the original file by <a href="http://onlinemd5.com/">checking its MD5 checksum</a>.</p>

    <p>If you can't or don't want to run program which your antivirus engine considers as infected,
        try using <a :href="`/dl/${version}/any`">platform-independent ZIP archive</a>.
        This distribution includes no native code and doesn't require
        Administrator privileges. It requires Java Runtime to be installed.</p>
    </div>
</template>

<script>
    export default {
        name: "DownloadWin28",
        props: {
            releaseDate: String,
            version: String,
            virustotalHash: String
        }
    }
</script>

<style scoped>

</style>
